export default __webpack_public_path__ + "static/media/samurai1.1791d5c3.jpg";